export const sizes = {
  container: {
    small: 992,
    medium: 1280,
    large: 1480,
  }
};
